// lib/download.ts — скачивание Blob-файла в браузере (V14 W9, §3.4/§3.6).
// Канон — downloadCsv (lib/csv.ts:40-48): temporary object URL + скрытый anchor + отзыв URL.
// Используется для XLSX-выгрузки отчётов (blob с сервера, filename из Content-Disposition).

/**
 * Инициирует скачивание файла из Blob: временный object URL, клик по скрытому
 * anchor, отзыв URL (браузеры без отзыва держат объект до закрытия вкладки).
 *
 * @param filename имя файла для скачивания (расширение включается).
 * @param blob     содержимое файла (например, XLSX с сервера).
 */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
